var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.844 10.065a.62.62 0 00-.205-.459l-4.533-4.518a.611.611 0 00-.458-.205.577.577 0 00-.594.588c0 .164.054.321.164.43l1.531 1.559 2.297 2.099-1.648-.103H4.751c-.355 0-.602.253-.602.609 0 .355.247.608.602.608h8.647l1.655-.103-2.304 2.099-1.531 1.558a.593.593 0 00-.164.431c0 .342.26.588.594.588a.623.623 0 00.445-.191l4.546-4.532a.62.62 0 00.205-.458z",
    fill: "currentColor"
  })));
}

export default __webpack_public_path__ + "static/media/arrow-right.6c527555.svg";
export { SvgArrowRight as ReactComponent };